import { Country } from '../../types';

export const COUNTRIES: Country[] = [
    {
      name: 'United States',
      abbr: 'US',
      zones: [
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Phoenix',
        'America/Los_Angeles',
        'America/Anchorage',
        'Pacific/Honolulu',
        'America/Detroit',
        'America/Indiana/Indianapolis',
        'America/Indiana/Vincennes',
        'America/Indiana/Knox',
        'America/Kentucky/Louisville',
        'America/Boise',
        'America/Adak'
      ]
    },
    {
      name: 'Afghanistan',
      abbr: 'AF',
      zones: [
        'Asia/Kabul'
      ]
    },
    {
      name: 'Albania',
      abbr: 'AL',
      zones: [
        'Europe/Tirane'
      ]
    },
    {
      name: 'Algeria',
      abbr: 'DZ',
      zones: [
        'Africa/Algiers'
      ]
    },
    {
      name: 'Andorra',
      abbr: 'AD',
      zones: [
        'Europe/Andorra'
      ]
    },
    {
      name: 'Angola',
      abbr: 'AO',
      zones: [
        'Africa/Luanda',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Anguilla',
      abbr: 'AI',
      zones: [
        'America/Anguilla',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Antigua & Barbuda',
      abbr: 'AG',
      zones: [
        'America/Antigua',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Argentina',
      abbr: 'AR',
      zones: [
        'America/Argentina/Buenos_Aires',
        'America/Argentina/Cordoba',
        'America/Argentina/Salta',
        'America/Argentina/Jujuy',
        'America/Argentina/Tucuman',
        'America/Argentina/Catamarca',
        'America/Argentina/La_Rioja',
        'America/Argentina/San_Juan',
        'America/Argentina/Mendoza',
        'America/Argentina/San_Luis',
        'America/Argentina/Rio_Gallegos',
        'America/Argentina/Ushuaia'
      ]
    },
    {
      name: 'Armenia',
      abbr: 'AM',
      zones: [
        'Asia/Yerevan'
      ]
    },
    {
      name: 'Aruba',
      abbr: 'AW',
      zones: [
        'America/Aruba',
        'America/Puerto_Rico',
        'America/Curacao'
      ]
    },
    {
      name: 'Australia',
      abbr: 'AU',
      zones: [
        'Australia/Lord_Howe',
        'Antarctica/Macquarie',
        'Australia/Hobart',
        'Australia/Currie',
        'Australia/Melbourne',
        'Australia/Sydney',
        'Australia/Broken_Hill',
        'Australia/Brisbane',
        'Australia/Lindeman',
        'Australia/Adelaide',
        'Australia/Darwin',
        'Australia/Perth',
        'Australia/Eucla'
      ]
    },
    {
      name: 'Austria',
      abbr: 'AT',
      zones: [
        'Europe/Vienna'
      ]
    },
    {
      name: 'Azerbaijan',
      abbr: 'AZ',
      zones: [
        'Asia/Baku'
      ]
    },
    {
      name: 'Bahamas',
      abbr: 'BS',
      zones: [
        'America/Nassau'
      ]
    },
    {
      name: 'Bahrain',
      abbr: 'BH',
      zones: [
        'Asia/Bahrain',
        'Asia/Qatar'
      ]
    },
    {
      name: 'Bangladesh',
      abbr: 'BD',
      zones: [
        'Asia/Dhaka'
      ]
    },
    {
      name: 'Barbados',
      abbr: 'BB',
      zones: [
        'America/Barbados'
      ]
    },
    {
      name: 'Belgium',
      abbr: 'BE',
      zones: [
        'Europe/Brussels'
      ]
    },
    {
      name: 'Belize',
      abbr: 'BZ',
      zones: [
        'America/Belize'
      ]
    },
    {
      name: 'Benin',
      abbr: 'BJ',
      zones: [
        'Africa/Porto-Novo',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Bermuda',
      abbr: 'BM',
      zones: [
        'Atlantic/Bermuda'
      ]
    },
    {
      name: 'Bhutan',
      abbr: 'BT',
      zones: [
        'Asia/Thimphu'
      ]
    },
    {
      name: 'Bolivia',
      abbr: 'BO',
      zones: [
        'America/La_Paz'
      ]
    },
    {
      name: 'Bonaire, St Eustatius & Saba',
      abbr: 'BQ',
      zones: [
        'America/Kralendijk',
        'America/Puerto_Rico'
      ]
    },
    {
      name: 'Bosnia & Herzegovina',
      abbr: 'BA',
      zones: [
        'Europe/Sarajevo',
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Botswana',
      abbr: 'BW',
      zones: [
        'Africa/Gaborone',
        'Africa/Maputo'
      ]
    },
    {
      name: 'Brazil',
      abbr: 'BR',
      zones: [
        'America/Noronha',
        'America/Belem',
        'America/Fortaleza',
        'America/Recife',
        'America/Araguaina',
        'America/Maceio',
        'America/Bahia',
        'America/Sao_Paulo',
        'America/Campo_Grande',
        'America/Cuiaba',
        'America/Santarem',
        'America/Porto_Velho',
        'America/Boa_Vista',
        'America/Manaus',
        'America/Eirunepe',
        'America/Rio_Branco'
      ]
    },
    {
      name: 'Brunei',
      abbr: 'BN',
      zones: [
        'Asia/Brunei'
      ]
    },
    {
      name: 'Bulgaria',
      abbr: 'BG',
      zones: [
        'Europe/Sofia'
      ]
    },
    {
      name: 'Burkina Faso',
      abbr: 'BF',
      zones: [
        'Africa/Ouagadougou',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Burundi',
      abbr: 'BI',
      zones: [
        'Africa/Bujumbura',
        'Africa/Maputo'
      ]
    },
    {
      name: 'Cambodia',
      abbr: 'KH',
      zones: [
        'Asia/Phnom_Penh',
        'Asia/Bangkok'
      ]
    },
    {
      name: 'Cameroon',
      abbr: 'CM',
      zones: [
        'Africa/Douala',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Canada',
      abbr: 'CA',
      zones: [
        'America/Toronto',
        'America/Vancouver',
        'America/Edmonton',
        'America/Halifax',
        'America/Winnipeg',
        'America/St_Johns',
        'America/Regina',
        'America/Moncton',
        'America/Creston',
        'America/Atikokan',
        'America/Blanc-Sablon'
      ]
    },
    {
      name: 'Cape Verde',
      abbr: 'CV',
      zones: [
        'Atlantic/Cape_Verde'
      ]
    },
    {
      name: 'Cayman Islands',
      abbr: 'KY',
      zones: [
        'America/Cayman',
        'America/Panama'
      ]
    },
    {
      name: 'Central African Rep.',
      abbr: 'CF',
      zones: [
        'Africa/Bangui',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Chad',
      abbr: 'TD',
      zones: [
        'Africa/Ndjamena'
      ]
    },
    {
      name: 'Chile',
      abbr: 'CL',
      zones: [
        'America/Santiago',
        'America/Punta_Arenas',
        'Pacific/Easter',
        'America/Coyhaique'
      ]
    },
    {
      name: 'China',
      abbr: 'CN',
      zones: [
        'Asia/Shanghai',
        'Asia/Urumqi'
      ]
    },
    {
      name: 'Colombia',
      abbr: 'CO',
      zones: [
        'America/Bogota'
      ]
    },
    {
      name: 'Comoros',
      abbr: 'KM',
      zones: [
        'Indian/Comoro',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Congo (Rep.)',
      abbr: 'CG',
      zones: [
        'Africa/Brazzaville',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Cook Islands',
      abbr: 'CK',
      zones: [
        'Pacific/Rarotonga'
      ]
    },
    {
      name: 'Costa Rica',
      abbr: 'CR',
      zones: [
        'America/Costa_Rica'
      ]
    },
    {
      name: 'Croatia',
      abbr: 'HR',
      zones: [
        'Europe/Zagreb',
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Curaçao',
      abbr: 'CW',
      zones: [
        'America/Curacao',
        'America/Puerto_Rico'
      ]
    },
    {
      name: 'Cyprus',
      abbr: 'CY',
      zones: [
        'Asia/Nicosia',
        'Asia/Famagusta'
      ]
    },
    {
      name: 'Czech Republic',
      abbr: 'CZ',
      zones: [
        'Europe/Prague'
      ]
    },
    {
      name: 'Côte d\'Ivoire',
      abbr: 'CI',
      zones: [
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Denmark',
      abbr: 'DK',
      zones: [
        'Europe/Copenhagen'
      ]
    },
    {
      name: 'Djibouti',
      abbr: 'DJ',
      zones: [
        'Africa/Djibouti',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Dominica',
      abbr: 'DM',
      zones: [
        'America/Dominica',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Dominican Republic',
      abbr: 'DO',
      zones: [
        'America/Santo_Domingo'
      ]
    },
    {
      name: 'East Timor',
      abbr: 'TL',
      zones: [
        'Asia/Dili'
      ]
    },
    {
      name: 'Ecuador',
      abbr: 'EC',
      zones: [
        'America/Guayaquil',
        'Pacific/Galapagos'
      ]
    },
    {
      name: 'Egypt',
      abbr: 'EG',
      zones: [
        'Africa/Cairo'
      ]
    },
    {
      name: 'El Salvador',
      abbr: 'SV',
      zones: [
        'America/El_Salvador'
      ]
    },
    {
      name: 'Equatorial Guinea',
      abbr: 'GQ',
      zones: [
        'Africa/Malabo',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Eritrea',
      abbr: 'ER',
      zones: [
        'Africa/Asmara',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Estonia',
      abbr: 'EE',
      zones: [
        'Europe/Tallinn'
      ]
    },
    {
      name: 'Ethiopia',
      abbr: 'ET',
      zones: [
        'Africa/Addis_Ababa',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Falkland Islands',
      abbr: 'FK',
      zones: [
        'Atlantic/Stanley'
      ]
    },
    {
      name: 'Faroe Islands',
      abbr: 'FO',
      zones: [
        'Atlantic/Faroe'
      ]
    },
    {
      name: 'Fiji',
      abbr: 'FJ',
      zones: [
        'Pacific/Fiji'
      ]
    },
    {
      name: 'Finland',
      abbr: 'FI',
      zones: [
        'Europe/Helsinki'
      ]
    },
    {
      name: 'France',
      abbr: 'FR',
      zones: [
        'Europe/Paris'
      ]
    },
    {
      name: 'French Guiana',
      abbr: 'GF',
      zones: [
        'America/Cayenne'
      ]
    },
    {
      name: 'French Polynesia',
      abbr: 'PF',
      zones: [
        'Pacific/Tahiti',
        'Pacific/Marquesas',
        'Pacific/Gambier'
      ]
    },
    {
      name: 'Gabon',
      abbr: 'GA',
      zones: [
        'Africa/Libreville',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Gambia',
      abbr: 'GM',
      zones: [
        'Africa/Banjul',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Georgia',
      abbr: 'GE',
      zones: [
        'Asia/Tbilisi'
      ]
    },
    {
      name: 'Germany',
      abbr: 'DE',
      zones: [
        'Europe/Berlin',
        'Europe/Busingen',
        'Europe/Zurich'
      ]
    },
    {
      name: 'Ghana',
      abbr: 'GH',
      zones: [
        'Africa/Accra'
      ]
    },
    {
      name: 'Gibraltar',
      abbr: 'GI',
      zones: [
        'Europe/Gibraltar'
      ]
    },
    {
      name: 'Greece',
      abbr: 'GR',
      zones: [
        'Europe/Athens'
      ]
    },
    {
      name: 'Greenland',
      abbr: 'GL',
      zones: [
        'America/Nuuk',
        'America/Danmarkshavn',
        'America/Scoresbysund',
        'America/Thule'
      ]
    },
    {
      name: 'Grenada',
      abbr: 'GD',
      zones: [
        'America/Grenada',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Guadeloupe',
      abbr: 'GP',
      zones: [
        'America/Guadeloupe',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Guam',
      abbr: 'GU',
      zones: [
        'Pacific/Guam'
      ]
    },
    {
      name: 'Guatemala',
      abbr: 'GT',
      zones: [
        'America/Guatemala'
      ]
    },
    {
      name: 'Guinea',
      abbr: 'GN',
      zones: [
        'Africa/Conakry',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Guinea-Bissau',
      abbr: 'GW',
      zones: [
        'Africa/Bissau'
      ]
    },
    {
      name: 'Guyana',
      abbr: 'GY',
      zones: [
        'America/Guyana'
      ]
    },
    {
      name: 'Haiti',
      abbr: 'HT',
      zones: [
        'America/Port-au-Prince'
      ]
    },
    {
      name: 'Honduras',
      abbr: 'HN',
      zones: [
        'America/Tegucigalpa'
      ]
    },
    {
      name: 'Hong Kong',
      abbr: 'HK',
      zones: [
        'Asia/Hong_Kong'
      ]
    },
    {
      name: 'Hungary',
      abbr: 'HU',
      zones: [
        'Europe/Budapest'
      ]
    },
    {
      name: 'Iceland',
      abbr: 'IS',
      zones: [
        'Atlantic/Reykjavik'
      ]
    },
    {
      name: 'India',
      abbr: 'IN',
      zones: [
        'Asia/Kolkata'
      ]
    },
    {
      name: 'Indonesia',
      abbr: 'ID',
      zones: [
        'Asia/Jakarta',
        'Asia/Pontianak',
        'Asia/Makassar',
        'Asia/Jayapura'
      ]
    },
    {
      name: 'Iraq',
      abbr: 'IQ',
      zones: [
        'Asia/Baghdad'
      ]
    },
    {
      name: 'Ireland',
      abbr: 'IE',
      zones: [
        'Europe/Dublin'
      ]
    },
    {
      name: 'Israel',
      abbr: 'IL',
      zones: [
        'Asia/Jerusalem'
      ]
    },
    {
      name: 'Italy',
      abbr: 'IT',
      zones: [
        'Europe/Rome'
      ]
    },
    {
      name: 'Jamaica',
      abbr: 'JM',
      zones: [
        'America/Jamaica'
      ]
    },
    {
      name: 'Japan',
      abbr: 'JP',
      zones: [
        'Asia/Tokyo'
      ]
    },
    {
      name: 'Jordan',
      abbr: 'JO',
      zones: [
        'Asia/Amman'
      ]
    },
    {
      name: 'Kazakhstan',
      abbr: 'KZ',
      zones: [
        'Asia/Almaty',
        'Asia/Qyzylorda',
        'Asia/Aqtobe',
        'Asia/Aqtau',
        'Asia/Atyrau',
        'Asia/Oral',
        'Asia/Qostanay'
      ]
    },
    {
      name: 'Kenya',
      abbr: 'KE',
      zones: [
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Korea (South)',
      abbr: 'KR',
      zones: [
        'Asia/Seoul'
      ]
    },
    {
      name: 'Kuwait',
      abbr: 'KW',
      zones: [
        'Asia/Kuwait',
        'Asia/Riyadh'
      ]
    },
    {
      name: 'Kyrgyzstan',
      abbr: 'KG',
      zones: [
        'Asia/Bishkek'
      ]
    },
    {
      name: 'Laos',
      abbr: 'LA',
      zones: [
        'Asia/Vientiane',
        'Asia/Bangkok'
      ]
    },
    {
      name: 'Latvia',
      abbr: 'LV',
      zones: [
        'Europe/Riga'
      ]
    },
    {
      name: 'Lebanon',
      abbr: 'LB',
      zones: [
        'Asia/Beirut'
      ]
    },
    {
      name: 'Lesotho',
      abbr: 'LS',
      zones: [
        'Africa/Maseru',
        'Africa/Johannesburg'
      ]
    },
    {
      name: 'Liberia',
      abbr: 'LR',
      zones: [
        'Africa/Monrovia'
      ]
    },
    {
      name: 'Libya',
      abbr: 'LY',
      zones: [
        'Africa/Tripoli'
      ]
    },
    {
      name: 'Liechtenstein',
      abbr: 'LI',
      zones: [
        'Europe/Vaduz',
        'Europe/Zurich'
      ]
    },
    {
      name: 'Lithuania',
      abbr: 'LT',
      zones: [
        'Europe/Vilnius'
      ]
    },
    {
      name: 'Luxembourg',
      abbr: 'LU',
      zones: [
        'Europe/Luxembourg'
      ]
    },
    {
      name: 'Macau',
      abbr: 'MO',
      zones: [
        'Asia/Macau'
      ]
    },
    {
      name: 'Macedonia',
      abbr: 'MK',
      zones: [
        'Europe/Skopje',
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Madagascar',
      abbr: 'MG',
      zones: [
        'Indian/Antananarivo',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Malawi',
      abbr: 'MW',
      zones: [
        'Africa/Blantyre',
        'Africa/Maputo'
      ]
    },
    {
      name: 'Malaysia',
      abbr: 'MY',
      zones: [
        'Asia/Kuala_Lumpur',
        'Asia/Kuching'
      ]
    },
    {
      name: 'Maldives',
      abbr: 'MV',
      zones: [
        'Indian/Maldives'
      ]
    },
    {
      name: 'Mali',
      abbr: 'ML',
      zones: [
        'Africa/Bamako',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Malta',
      abbr: 'MT',
      zones: [
        'Europe/Malta'
      ]
    },
    {
      name: 'Marshall Islands',
      abbr: 'MH',
      zones: [
        'Pacific/Majuro',
        'Pacific/Kwajalein'
      ]
    },
    {
      name: 'Martinique',
      abbr: 'MQ',
      zones: [
        'America/Martinique'
      ]
    },
    {
      name: 'Mauritania',
      abbr: 'MR',
      zones: [
        'Africa/Nouakchott',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Mauritius',
      abbr: 'MU',
      zones: [
        'Indian/Mauritius'
      ]
    },
    {
      name: 'Mexico',
      abbr: 'MX',
      zones: [
        'America/Mexico_City',
        'America/Cancun',
        'America/Merida',
        'America/Monterrey',
        'America/Matamoros',
        'America/Mazatlan',
        'America/Chihuahua',
        'America/Ojinaga',
        'America/Hermosillo',
        'America/Tijuana',
        'America/Bahia_Banderas',
        'America/Ciudad_Juarez'
      ]
    },
    {
      name: 'Micronesia',
      abbr: 'FM',
      zones: [
        'Pacific/Chuuk',
        'Pacific/Pohnpei',
        'Pacific/Kosrae'
      ]
    },
    {
      name: 'Moldova',
      abbr: 'MD',
      zones: [
        'Europe/Chisinau'
      ]
    },
    {
      name: 'Monaco',
      abbr: 'MC',
      zones: [
        'Europe/Monaco'
      ]
    },
    {
      name: 'Mongolia',
      abbr: 'MN',
      zones: [
        'Asia/Ulaanbaatar',
        'Asia/Hovd',
        'Asia/Choibalsan'
      ]
    },
    {
      name: 'Montenegro',
      abbr: 'ME',
      zones: [
        'Europe/Podgorica',
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Montserrat',
      abbr: 'MS',
      zones: [
        'America/Montserrat',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Morocco',
      abbr: 'MA',
      zones: [
        'Africa/Casablanca'
      ]
    },
    {
      name: 'Mozambique',
      abbr: 'MZ',
      zones: [
        'Africa/Maputo'
      ]
    },
    {
      name: 'Myanmar (Burma)',
      abbr: 'MM',
      zones: [
        'Asia/Yangon'
      ]
    },
    {
      name: 'Namibia',
      abbr: 'NA',
      zones: [
        'Africa/Windhoek'
      ]
    },
    {
      name: 'Nepal',
      abbr: 'NP',
      zones: [
        'Asia/Kathmandu'
      ]
    },
    {
      name: 'Netherlands',
      abbr: 'NL',
      zones: [
        'Europe/Amsterdam',
        'Europe/Berlin'
      ]
    },
    {
      name: 'New Caledonia',
      abbr: 'NC',
      zones: [
        'Pacific/Noumea'
      ]
    },
    {
      name: 'New Zealand',
      abbr: 'NZ',
      zones: [
        'Pacific/Auckland',
        'Pacific/Chatham'
      ]
    },
    {
      name: 'Nicaragua',
      abbr: 'NI',
      zones: [
        'America/Managua'
      ]
    },
    {
      name: 'Niger',
      abbr: 'NE',
      zones: [
        'Africa/Niamey',
        'Africa/Lagos'
      ]
    },
    {
      name: 'Nigeria',
      abbr: 'NG',
      zones: [
        'Africa/Lagos'
      ]
    },
    {
      name: 'Northern Mariana Islands',
      abbr: 'MP',
      zones: [
        'Pacific/Saipan',
        'Pacific/Guam'
      ]
    },
    {
      name: 'Norway',
      abbr: 'NO',
      zones: [
        'Europe/Oslo'
      ]
    },
    {
      name: 'Oman',
      abbr: 'OM',
      zones: [
        'Asia/Muscat',
        'Asia/Dubai'
      ]
    },
    {
      name: 'Pakistan',
      abbr: 'PK',
      zones: [
        'Asia/Karachi'
      ]
    },
    {
      name: 'Palau',
      abbr: 'PW',
      zones: [
        'Pacific/Palau'
      ]
    },
    {
      name: 'Palestine',
      abbr: 'PS',
      zones: [
        'Asia/Gaza',
        'Asia/Hebron'
      ]
    },
    {
      name: 'Panama',
      abbr: 'PA',
      zones: [
        'America/Panama'
      ]
    },
    {
      name: 'Papua New Guinea',
      abbr: 'PG',
      zones: [
        'Pacific/Port_Moresby',
        'Pacific/Bougainville'
      ]
    },
    {
      name: 'Paraguay',
      abbr: 'PY',
      zones: [
        'America/Asuncion'
      ]
    },
    {
      name: 'Peru',
      abbr: 'PE',
      zones: [
        'America/Lima'
      ]
    },
    {
      name: 'Philippines',
      abbr: 'PH',
      zones: [
        'Asia/Manila'
      ]
    },
    {
      name: 'Poland',
      abbr: 'PL',
      zones: [
        'Europe/Warsaw'
      ]
    },
    {
      name: 'Portugal',
      abbr: 'PT',
      zones: [
        'Europe/Lisbon',
        'Atlantic/Madeira',
        'Atlantic/Azores'
      ]
    },
    {
      name: 'Puerto Rico',
      abbr: 'PR',
      zones: [
        'America/Puerto_Rico'
      ]
    },
    {
      name: 'Qatar',
      abbr: 'QA',
      zones: [
        'Asia/Qatar'
      ]
    },
    {
      name: 'Romania',
      abbr: 'RO',
      zones: [
        'Europe/Bucharest'
      ]
    },
    {
      name: 'Rwanda',
      abbr: 'RW',
      zones: [
        'Africa/Kigali',
        'Africa/Maputo'
      ]
    },
    {
      name: 'Réunion',
      abbr: 'RE',
      zones: [
        'Indian/Reunion'
      ]
    },
    {
      name: 'Samoa (American)',
      abbr: 'AS',
      zones: [
        'Pacific/Pago_Pago'
      ]
    },
    {
      name: 'Samoa (western)',
      abbr: 'WS',
      zones: [
        'Pacific/Apia'
      ]
    },
    {
      name: 'San Marino',
      abbr: 'SM',
      zones: [
        'Europe/San_Marino',
        'Europe/Rome'
      ]
    },
    {
      name: 'Sao Tome & Principe',
      abbr: 'ST',
      zones: [
        'Africa/Sao_Tome',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Saudi Arabia',
      abbr: 'SA',
      zones: [
        'Asia/Riyadh'
      ]
    },
    {
      name: 'Senegal',
      abbr: 'SN',
      zones: [
        'Africa/Dakar',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Serbia',
      abbr: 'RS',
      zones: [
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Seychelles',
      abbr: 'SC',
      zones: [
        'Indian/Mahe'
      ]
    },
    {
      name: 'Sierra Leone',
      abbr: 'SL',
      zones: [
        'Africa/Freetown',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Singapore',
      abbr: 'SG',
      zones: [
        'Asia/Singapore'
      ]
    },
    {
      name: 'Slovakia',
      abbr: 'SK',
      zones: [
        'Europe/Bratislava',
        'Europe/Prague'
      ]
    },
    {
      name: 'Slovenia',
      abbr: 'SI',
      zones: [
        'Europe/Ljubljana',
        'Europe/Belgrade'
      ]
    },
    {
      name: 'Solomon Islands',
      abbr: 'SB',
      zones: [
        'Pacific/Guadalcanal'
      ]
    },
    {
      name: 'Somalia',
      abbr: 'SO',
      zones: [
        'Africa/Mogadishu',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'South Africa',
      abbr: 'ZA',
      zones: [
        'Africa/Johannesburg'
      ]
    },
    {
      name: 'South Sudan',
      abbr: 'SS',
      zones: [
        'Africa/Juba'
      ]
    },
    {
      name: 'Spain',
      abbr: 'ES',
      zones: [
        'Europe/Madrid',
        'Africa/Ceuta',
        'Atlantic/Canary'
      ]
    },
    {
      name: 'Sri Lanka',
      abbr: 'LK',
      zones: [
        'Asia/Colombo'
      ]
    },
    {
      name: 'St Barthélemy',
      abbr: 'BL',
      zones: [
        'America/St_Barthelemy',
        'America/Puerto_Rico'
      ]
    },
    {
      name: 'St Helena',
      abbr: 'SH',
      zones: [
        'Atlantic/St_Helena',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'St Kitts & Nevis',
      abbr: 'KN',
      zones: [
        'America/St_Kitts',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'St Lucia',
      abbr: 'LC',
      zones: [
        'America/St_Lucia',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'St Maarten (Dutch)',
      abbr: 'SX',
      zones: [
        'America/Lower_Princes',
        'America/Puerto_Rico',
        'America/Curacao'
      ]
    },
    {
      name: 'St Martin (French)',
      abbr: 'MF',
      zones: [
        'America/Marigot',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'St Pierre & Miquelon',
      abbr: 'PM',
      zones: [
        'America/Miquelon'
      ]
    },
    {
      name: 'St Vincent',
      abbr: 'VC',
      zones: [
        'America/St_Vincent',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Sudan',
      abbr: 'SD',
      zones: [
        'Africa/Khartoum'
      ]
    },
    {
      name: 'Suriname',
      abbr: 'SR',
      zones: [
        'America/Paramaribo'
      ]
    },
    {
      name: 'Swaziland',
      abbr: 'SZ',
      zones: [
        'Africa/Mbabane',
        'Africa/Johannesburg'
      ]
    },
    {
      name: 'Sweden',
      abbr: 'SE',
      zones: [
        'Europe/Stockholm'
      ]
    },
    {
      name: 'Switzerland',
      abbr: 'CH',
      zones: [
        'Europe/Zurich'
      ]
    },
    {
      name: 'Taiwan',
      abbr: 'TW',
      zones: [
        'Asia/Taipei'
      ]
    },
    {
      name: 'Tajikistan',
      abbr: 'TJ',
      zones: [
        'Asia/Dushanbe'
      ]
    },
    {
      name: 'Tanzania',
      abbr: 'TZ',
      zones: [
        'Africa/Dar_es_Salaam',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Thailand',
      abbr: 'TH',
      zones: [
        'Asia/Bangkok'
      ]
    },
    {
      name: 'Togo',
      abbr: 'TG',
      zones: [
        'Africa/Lome',
        'Africa/Abidjan'
      ]
    },
    {
      name: 'Tonga',
      abbr: 'TO',
      zones: [
        'Pacific/Tongatapu'
      ]
    },
    {
      name: 'Trinidad & Tobago',
      abbr: 'TT',
      zones: [
        'America/Port_of_Spain',
        'America/Puerto_Rico'
      ]
    },
    {
      name: 'Tunisia',
      abbr: 'TN',
      zones: [
        'Africa/Tunis'
      ]
    },
    {
      name: 'Turkey',
      abbr: 'TR',
      zones: [
        'Europe/Istanbul'
      ]
    },
    {
      name: 'Turkmenistan',
      abbr: 'TM',
      zones: [
        'Asia/Ashgabat'
      ]
    },
    {
      name: 'Turks & Caicos Is',
      abbr: 'TC',
      zones: [
        'America/Grand_Turk'
      ]
    },
    {
      name: 'Tuvalu',
      abbr: 'TV',
      zones: [
        'Pacific/Funafuti'
      ]
    },
    {
      name: 'US minor outlying islands',
      abbr: 'UM',
      zones: [
        'Pacific/Midway',
        'Pacific/Wake',
        'Pacific/Pago_Pago',
        'Pacific/Honolulu'
      ]
    },
    {
      name: 'Uganda',
      abbr: 'UG',
      zones: [
        'Africa/Kampala',
        'Africa/Nairobi'
      ]
    },
    {
      name: 'Ukraine',
      abbr: 'UA',
      zones: [
        'Europe/Kyiv'
      ]
    },
    {
      name: 'United Arab Emirates',
      abbr: 'AE',
      zones: [
        'Asia/Dubai'
      ]
    },
    {
      name: 'United Kingdom',
      abbr: 'GB',
      zones: [
        'Europe/London',
        'Europe/Jersey',
        'Europe/Guernsey',
        'Europe/Isle_of_Man'
      ]
    },
    {
      name: 'Uruguay',
      abbr: 'UY',
      zones: [
        'America/Montevideo'
      ]
    },
    {
      name: 'Uzbekistan',
      abbr: 'UZ',
      zones: [
        'Asia/Samarkand',
        'Asia/Tashkent'
      ]
    },
    {
      name: 'Vanuatu',
      abbr: 'VU',
      zones: [
        'Pacific/Efate'
      ]
    },
    {
      name: 'Vatican City',
      abbr: 'VA',
      zones: [
        'Europe/Vatican',
        'Europe/Rome'
      ]
    },
    {
      name: 'Venezuela',
      abbr: 'VE',
      zones: [
        'America/Caracas'
      ]
    },
    {
      name: 'Vietnam',
      abbr: 'VN',
      zones: [
        'Asia/Ho_Chi_Minh',
        'Asia/Bangkok'
      ]
    },
    {
      name: 'Virgin Islands (UK)',
      abbr: 'VG',
      zones: [
        'America/Tortola',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Virgin Islands (US)',
      abbr: 'VI',
      zones: [
        'America/St_Thomas',
        'America/Puerto_Rico',
        'America/Port_of_Spain'
      ]
    },
    {
      name: 'Yemen',
      abbr: 'YE',
      zones: [
        'Asia/Aden',
        'Asia/Riyadh'
      ]
    },
    {
      name: 'Zambia',
      abbr: 'ZM',
      zones: [
        'Africa/Lusaka',
        'Africa/Maputo'
      ]
    },
    {
      name: 'Zimbabwe',
      abbr: 'ZW',
      zones: [
        'Africa/Harare',
        'Africa/Maputo'
      ]
    }
  ];
